module.exports = __webpack_public_path__ + "img/back neck drop.5712d977.png";